import Highlight from './Highlight'

export * from './Highlight'
export default Highlight
